import React, { useRef } from 'react';

import Welcome from './Welcome/Welcome.jsx';
import Gallery from './Gallery/Gallery.jsx';
import PriceList from './PriceList/PriceList.jsx';
import Services from './Services/Services.jsx';
import Contacts from './Contacts/Contacts.jsx';

import "./LandingPage.scss";


export const LandingPage = (props)=>{
    const {} = props;

    return (
        <main className="LandingPage">
            <Welcome/>
            <Gallery/>
            <PriceList/>
            <Services/>
            <Contacts/>
        </main>
    )
}
